import { hasPermission } from '@/hooks/useBackendMenu'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import {
    CompensacaoDia,
    compensacaoFolgas,
    createCompensacaoFolgaSchema,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { LancamentosAnterioresAsync } from 'templates/ManutencaoDoPonto/Ausencias/lancamentos-anteriores'
import { useUpdateDigitacaoQueryData } from 'templates/ManutencaoDoPonto/Digitacao/pages/useDigitacaoData'
import FormNovaCompensacaoFeriado from '../forms/NovaCompensacaoFeriado'

export default function NovaCompensacaoFolga() {
    const { dia } = useParams()
    const navigate = useNavigate()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { mutateAsync } = compensacaoFolgas.mutations.useCreate()

    if (!dia) navigate(-1)

    const empresaId = useStore(state => state.companyId)
    const funcionarioId = useStore(state => state.employeeId)

    const handleSubmit: SubmitHandler<CompensacaoDia> = async data => {
        await mutateAsync(
            {
                ...data,
                dataCompensacao: dayjs(dia).toDate(),
                dataFeriado: dayjs(data.dataFeriado).toDate(),
            },
            {
                onSuccess: payload => {
                    setQueryData('COMPENSACAO_FERIADO', payload)
                    toast.success('Compensação de folga criada com sucesso')
                },
                onError: e => {
                    toast.error(e.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            width="lg"
            onSubmit={handleSubmit}
            defaultValues={{
                dataCompensacao: dayjs(dia).format('YYYY-MM-DD'),
                funcionarioId,
                empresaId,
            }}
            schema={createCompensacaoFolgaSchema}
            open={hasPermission(['create', 'CompensaçãoDeFolgas'])}
        >
            <Dialog.Title>Compensação de folga</Dialog.Title>
            <Dialog.Content>
                <FormNovaCompensacaoFeriado labelDataOrigem="Data da folga" />
                <LancamentosAnterioresAsync tipoAusencia="Compensação de folga" />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
